import { Box, Card, styled } from '@mui/material';

export const CardStyled = styled(Card)({
  width: '210px',
  minHeight: '107px',
  backgroundColor: '#FAFAFA',
  border: '2px solid white',
  boxShadow: 'unset',
  borderRadius: '8px',
  padding: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',

  '&:hover': {
    backgroundColor: '#F5F6F6',
  },
});

export const ShortcutsListContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down(1000)]: {
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
}));

export const ShortcutsContainer = styled(Box)({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  color: '#9EA2A2',
  padding: '10px',
  fontSize: '14px',
});
